import "./daily-quote.css";

// v30 — citát dňa pod zoznamom návykov. Zámerne BEZ AI: text sa vyberá zo 100-položkového
// zoznamu podľa dňa v roku (ai.quote_of_day, chodí v /api/state), takže je pre všetkých
// rovnaký, deterministický a nestojí ani jedno volanie modelu.
//
// Vizuálne je to bodka za dňom, nie ďalšia karta na odškrtnutie: žiadny rám ani pozadie,
// len tenký prúžok vo farbe témy a tichý text. Autor sa oddeľuje pomlčkou už na serveri.

export function DailyQuote({ text }) {
  if (!text) return null;
  return <blockquote className="bz-dayquote"><p className="bz-dayquote__text">{text}</p></blockquote>;
}
